import { useSyncExternalStore } from 'react';
import { money, moneyShort } from '../lib/format.ts';

// "Esconder valores" (o olho): preferência deste aparelho
const KEY = 'sublime-ocultar';
const listeners = new Set<() => void>();
const read = () => { try { return localStorage.getItem(KEY) === '1'; } catch { return false; } };
export function useHiddenMoney(): [boolean, () => void] {
  const hid = useSyncExternalStore((cb) => { listeners.add(cb); return () => listeners.delete(cb); }, read);
  return [hid, () => { try { localStorage.setItem(KEY, read() ? '0' : '1'); } catch { /* sem armazenamento */ } listeners.forEach((l) => l()); }];
}

export const Mv = ({ c }: { c: number }) => <span className="mv">{moneyShort(c)}</span>;
export const Mf = ({ c }: { c: number }) => <span className="mv">{money(c)}</span>;

export function BigMoney({ c }: { c: number }) {
  const [r, cents] = (c / 100).toFixed(2).split('.');
  return <><sup>R$</sup>{Number(r).toLocaleString('pt-BR')}<sup>,{cents}</sup></>;
}
